<ng-container *ngComponentOutlet="nodeFactory.getComponentForNodeType(node.type); injector: createInjectorForNode()"></ng-container>
@if (node.children?.length) {
  <div class="children">
    @for (child of node.children; track $index) {
      <app-document-node-view [node]="child"></app-document-node-view>
    }
  </div>
}
